import { useEffect } from "react";
import { useStore } from "@/context/StoreContext";
import { getConsent } from "@/lib/events";

/** Injects GA4, Meta Pixel, GSC verification and custom scripts from admin settings.
 * Marketing tags load only after marketing consent; GA4 loads with Consent Mode
 * v2 defaults (denied) so pings stay cookieless until consent. */
export default function TrackingScripts() {
  const { config } = useStore();

  useEffect(() => {
    const integ = config?.integrations_public || {};

    // Search Console verification is harmless — always inject
    if (integ.gsc_verification && !document.querySelector('meta[name="google-site-verification"]')) {
      const m = document.createElement("meta");
      m.name = "google-site-verification";
      m.content = integ.gsc_verification;
      document.head.appendChild(m);
    }

    // GA4 — consent mode already defaulted to denied by ConsentBanner
    if (integ.ga4_measurement_id && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${integ.ga4_measurement_id}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", integ.ga4_measurement_id, { send_page_view: false }); // event layer owns page_view
    }

    const consent = getConsent();

    // Meta pixel — marketing consent only
    if (integ.meta_pixel_id && consent?.marketing && !document.getElementById("meta-pixel")) {
      const s = document.createElement("script");
      s.id = "meta-pixel";
      s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${integ.meta_pixel_id}');`;
      document.head.appendChild(s);
    }

    // Custom scripts — after any consent
    if (consent?.marketing && integ.custom_head && !document.getElementById("custom-head-script")) {
      const holder = document.createElement("div");
      holder.id = "custom-head-script";
      holder.innerHTML = integ.custom_head;
      [...holder.querySelectorAll("script")].forEach((old) => {
        const s = document.createElement("script");
        if (old.src) s.src = old.src; else s.textContent = old.textContent;
        document.head.appendChild(s);
      });
    }
    if (consent?.marketing && integ.custom_body && !document.getElementById("custom-body-script")) {
      const holder = document.createElement("div");
      holder.id = "custom-body-script";
      holder.innerHTML = integ.custom_body;
      [...holder.querySelectorAll("script")].forEach((old) => {
        const s = document.createElement("script");
        if (old.src) s.src = old.src; else s.textContent = old.textContent;
        document.body.appendChild(s);
      });
    }
  }, [config]);

  return null;
}
